module.exports = __webpack_public_path__ + "static/media/kids_in_clouds.3eb55060.png";